import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
class toaster {
  async successMessage(message) {
    // Force immediate display with setTimeout to ensure it's added to the next event loop
    setTimeout(() => {
      toast.success(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }, 0);
  }

  async errorMessage(message) {
    setTimeout(() => {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }, 0);
  }

  async infoMessage(message) {
    setTimeout(() => {
      toast.info(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }, 0);
  }

  async warningMessage(message) {
    setTimeout(() => {
      toast.warning(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }, 0);
  }
}
export default toaster;
